module.exports = __webpack_public_path__ + "img/dj_white.b34f484c.jpg";